import { createApi } from "@reduxjs/toolkit/query/react";
import { RestaurantTable, RestaurantTableFormData } from "./table.type";
import { CollectionData, PaginationResults, TypeQuery } from "@/lib/type";
import { baseQueryWithLogout } from "@/lib/baseQuery";
import { Roles } from "../user/user.type";

export const TableApi = createApi({
  reducerPath: "tableApi",
  tagTypes: ["table"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getRestaurantTables: build.query<
      PaginationResults<RestaurantTable>,
      TypeQuery
    >({
      query: ({ restaurantId, role, ...query }) => {
        if (restaurantId && role === Roles.owner) {
          return {
            url: `restaurant_tables?restaurant.id=${restaurantId}`,
            params: { ...query },
          };
        }
        return {
          url: `restaurants/${restaurantId}/restaurant_tables`,
          params: { ...query },
        };
      },
      providesTags: ["table"],
      transformResponse: (data: CollectionData<RestaurantTable>) => {
        return {
          results: data["hydra:member"],
          count: data["hydra:totalItems"],
        };
      },
    }),

    createOrUpdateTable: build.mutation<
      RestaurantTable,
      { id?: string; data: RestaurantTableFormData }
    >({
      query: ({ id, data }) => {
        if (id) {
          return {
            url: `restaurant_tables/${id}`,
            method: "PATCH",
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "application/merge-patch+json",
              accept: "application/ld+json",
            },
          };
        }
        return {
          url: "restaurant_tables",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["table"],
    }),

    deleteTable: build.mutation<RestaurantTable, string>({
      query: (id) => ({
        url: `restaurant_tables/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["table"],
    }),
  }),
});

export const {
	useGetRestaurantTablesQuery,
	useCreateOrUpdateTableMutation,
	useDeleteTableMutation,
} = TableApi;
